import { gsap } from "gsap";
import { lenis } from "./scroll";

export default class NavigationHandler {
	init() {
		const header = document.querySelector('header');
		
		const links = header.querySelectorAll("a");
		for (let i = 0; i < links.length; i++) {
			const link = links[i];
			link.classList.remove("is-active");
			if (link.href === location.href) {
				link.classList.add("is-active");
			}
		}
		
		header.style.transform = `translateY(0px)`;
		header.classList.remove('bg-darkBlue');
		gsap.utils.toArray(header.querySelectorAll('[data-navigation="parent"]')).forEach((e) => {
			e.classList.remove('is-hover')
		});
		if (header.querySelector('.main-menu') && header.querySelector('.main-menu').classList.contains('is-active')) {
			header.querySelector('.main-menu').classList.remove('is-active');
		};
		lenis.start();
	}
	mobile() {
		if (window.innerWidth < 769) { 
			const accordions = gsap.utils.toArray('[data-navigation="parent"]');
			
			accordions.forEach((accordion, index) => {
				const trigger = accordion.firstElementChild;
				const content = accordion.querySelector('[data-navigation="sub-menu"]');
				accordion.style.height = `${trigger.offsetHeight}px`;
		
				trigger.addEventListener('click', () => {
					const isActive = accordion.classList.contains('is-active');
					accordion.classList.toggle('is-active');
		
					const targetHeight = isActive
						? trigger.offsetHeight
						: trigger.offsetHeight + content.offsetHeight;
		
					gsap.to(accordion, { height: targetHeight, duration: 0.5, ease: 'power4.out' });
				});
			});
		
			function updateAccordionHeight(accordion) {
				const trigger = accordion.firstElementChild;
				const content = accordion.querySelector('[data-navigation="sub-menu"]');
				const isActive = accordion.classList.contains('is-active');
				const targetHeight = isActive 
					? trigger.offsetHeight + content.scrollHeight
					: trigger.offsetHeight;
				gsap.set(accordion, { height: targetHeight });
			}
			window.addEventListener('resize', () => accordions.forEach(updateAccordionHeight));
		}
	}
	reset() {
		const accordions = gsap.utils.toArray('[data-navigation="parent"]');
		accordions.forEach((accordion) => {
			const trigger = accordion.firstElementChild;
			accordion.classList.remove('is-active');
			gsap.set(accordion, { height: trigger.offsetHeight });
			document.querySelector('[data-navigation="trigger"]').textContent = 'Menu';
		});
		if (document.querySelector('[data-search="container"]').classList.contains('is-active')) {
			document.querySelector('[data-search="container"]').classList.remove('is-active');
		}
	}
}